"use client";
import {
  __spreadValues
} from "../chunk-GOCCUU3Z.js";
import {
  OnRampAsset,
  Network,
  getOnRampNetworks,
  getOnRampAssets,
  toAssetInfoArray
} from "@getpara/web-sdk";
function getCurrencyCode({ assetInfo }, { network, asset, provider }) {
  var _a, _b, _c;
  return (_c = (_b = (_a = Object.values(assetInfo).reduce((acc, record) => __spreadValues(__spreadValues({}, acc), record), {})[network]) == null ? void 0 : _a[asset]) == null ? void 0 : _b[provider]) == null ? void 0 : _c[0];
}
function getCurrencyCodes({ assetInfo, allowedAssets, defaultOnRampNetwork, defaultOnRampAsset }, {
  provider,
  purchaseType,
  walletType
}) {
  let defaultCurrencyCode;
  const currencyCodes = getOnRampNetworks(assetInfo, {
    walletType,
    allowed: allowedAssets ? Object.keys(allowedAssets) : void 0
  }).sort((a, b) => a === defaultOnRampNetwork ? -1 : b === defaultOnRampNetwork ? 1 : 0).reduce((acc, network) => {
    const allowed = Array.isArray(allowedAssets == null ? void 0 : allowedAssets[network]) ? allowedAssets[network] : void 0;
    return [
      ...acc,
      ...getOnRampAssets(assetInfo, { walletType, network, allowed }).sort((a, b) => a === defaultOnRampAsset ? -1 : b === defaultOnRampAsset ? 1 : 0).map((asset) => {
        var _a, _b, _c, _d, _e, _f;
        if (network === defaultOnRampNetwork && asset === defaultOnRampAsset) {
          defaultCurrencyCode = (_c = (_b = (_a = assetInfo[walletType]) == null ? void 0 : _a[network]) == null ? void 0 : _b[asset]) == null ? void 0 : _c[provider][0];
        }
        return (_f = (_e = (_d = assetInfo[walletType]) == null ? void 0 : _d[network]) == null ? void 0 : _e[asset]) == null ? void 0 : _f[provider];
      }).filter((entry) => !!entry && !!entry[1][purchaseType]).map(([code]) => code)
    ];
  }, []).filter((code) => !!code);
  return { currencyCodes, defaultCurrencyCode: defaultCurrencyCode || currencyCodes[0] };
}
function reverseCurrencyLookup(data, provider, code) {
  const row = toAssetInfoArray(data).find(
    ([_, __, ___, providers]) => [code.toUpperCase(), code.toLowerCase()].includes(providers[provider][0])
  );
  return [row == null ? void 0 : row[1], row == null ? void 0 : row[2]];
}
const TestNetworks = [
  { main: Network.ETHEREUM, test: Network.SEPOLIA },
  { main: Network.SOLANA, test: Network.SOLANA_DEVNET }
];
function getNetworkTestEquivalent(network) {
  var _a;
  return (_a = TestNetworks.find(({ main }) => main === network)) == null ? void 0 : _a.test;
}
function getNetworkOrMainNetEquivalent(network, testMode) {
  var _a, _b;
  return testMode ? (_b = (_a = TestNetworks.find(({ test }) => test === network)) == null ? void 0 : _a.main) != null ? _b : network : network;
}
const NetworkChainIds = [
  { chainId: "11155111", network: Network.SEPOLIA },
  { chainId: "1", network: Network.ETHEREUM },
  { chainId: "137", network: Network.POLYGON },
  { chainId: "42220", network: Network.CELO },
  { chainId: "8453", network: Network.BASE },
  { chainId: "42161", network: Network.ARBITRUM },
  { chainId: "10", network: Network.OPTIMISM }
];
function getChainId(network) {
  var _a, _b;
  return (_b = (_a = NetworkChainIds.find(({ network: n }) => n === network)) == null ? void 0 : _a.chainId) != null ? _b : void 0;
}
function getNetworkFromChainId(chainId) {
  var _a;
  return chainId ? (_a = NetworkChainIds.find(({ chainId: c }) => c === chainId)) == null ? void 0 : _a.network : void 0;
}
const ETH_CONTRACT_ADDRESS = "0x0000000000000000000000000000000000000000";
const NetworkAssetAddresses = [
  { network: Network.ETHEREUM, asset: OnRampAsset.USDC, address: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48" },
  { network: Network.POLYGON, asset: OnRampAsset.USDC, address: "0x3c499c542cef5e3811e1192ce70d8cc03d5c3359" },
  { network: Network.CELO, asset: OnRampAsset.USDC, address: "0xcebA9300f2b948710d2653dD7B07f33A8B32118C" },
  { network: Network.BASE, asset: OnRampAsset.USDC, address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913" },
  { network: Network.ARBITRUM, asset: OnRampAsset.USDC, address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831" },
  { network: Network.OPTIMISM, asset: OnRampAsset.USDC, address: "0x0b2c639c533813f4aa9d7837caf62653d097ff85" },
  { network: Network.SOLANA, asset: OnRampAsset.USDC, address: "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v" },
  { network: Network.SOLANA_DEVNET, asset: OnRampAsset.USDC, address: "4zMMC9srt5Ri5X14GAgXhaHii3GnPAEERYPJgZJDncDU" },
  { network: Network.SEPOLIA, asset: OnRampAsset.USDC, address: "0x1c7D4B196Cb0C7B01d743Fbc6116a902379C7238" },
  { network: Network.SOLANA_DEVNET, asset: OnRampAsset.TETHER, address: "EJwZgeZrdC8TXTQbQBoL6bfuAnFUUy1PVCMB4DYPzVaS" }
];
function getAssetFromContractAddress(network, contractAddress) {
  var _a, _b;
  if (contractAddress === ETH_CONTRACT_ADDRESS) {
    return OnRampAsset.ETHEREUM;
  }
  const checkNetworks = [network, (_a = getNetworkOrMainNetEquivalent(network)) != null ? _a : void 0].filter((n) => !!n).map((n) => Network[n]);
  return (_b = NetworkAssetAddresses.find(
    (row) => checkNetworks.includes(row.network) && row.asset.toLowerCase() === contractAddress.toLowerCase()
  )) == null ? void 0 : _b.asset;
}
function getContractAddressFromAsset(network, asset) {
  var _a;
  if (asset === OnRampAsset.ETHEREUM) {
    return ETH_CONTRACT_ADDRESS;
  }
  return (_a = NetworkAssetAddresses.find((row) => row.network === network && row.asset === asset)) == null ? void 0 : _a.address;
}
export * from "./offRampSend.js";
export * from "./getDeviceLogo.js";
export * from "./getDeviceModelName.js";
export * from "./getBrowserName.js";
export * from "./formatBiometricHints.js";
export * from "./formatPhoneNumber.js";
export * from "./getExternalWalletDisplayName.js";
export {
  NetworkAssetAddresses,
  NetworkChainIds,
  TestNetworks,
  getAssetFromContractAddress,
  getChainId,
  getContractAddressFromAsset,
  getCurrencyCode,
  getCurrencyCodes,
  getNetworkFromChainId,
  getNetworkOrMainNetEquivalent,
  getNetworkTestEquivalent,
  reverseCurrencyLookup
};
